import { render, staticRenderFns } from "./diagnosisUpdateModal.vue?vue&type=template&id=10c7d5cc&"
import script from "./diagnosisUpdateModal.vue?vue&type=script&lang=js&"
export * from "./diagnosisUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports